var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E81F7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3C9.6,3,7.5,4.5,6.5,6.9c-0.7,1.8-0.7,3.9,0.1,5.7l1.6,3.6v2c0,1,0.8,1.8,1.8,1.8h0c0,0.6,0.4,1,1,1h1.8    c0.6,0,1-0.4,1-1h0c1,0,1.8-0.8,1.8-1.8v-2l1.6-3.6c0.8-1.8,0.8-3.9,0.1-5.7C16.5,4.5,14.4,3,12,3z M13.8,18h-3.5v-1h3.5V18z     M15.6,11.8L14.1,15H13v-1.3c0.5-0.1,0.8-0.5,0.8-1c0-0.6-0.4-1-1-1h-1.7c-0.6,0-1,0.4-1,1c0,0.5,0.4,0.9,0.8,1V15H9.9l-1.4-3.2    C7.9,10.5,7.9,9,8.4,7.7C9.1,6,10.4,5,12,5s2.9,1,3.6,2.7C16.1,9,16.1,10.5,15.6,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l1,1C3.5,6.9,3.7,7,4,7s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L3.7,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,10c0.6,0,1-0.4,1-1S3.6,8,3,8H2C1.4,8,1,8.4,1,9s0.4,1,1,1H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3,11.3l-1,1c-0.4,0.4-0.4,1,0,1.4C2.5,13.9,2.7,14,3,14s0.5-0.1,0.7-0.3l1-1c0.4-0.4,0.4-1,0-1.4S3.7,10.9,3.3,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,11.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l1,1c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4    L20.7,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,8h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S22.6,8,22,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,7c0.3,0,0.5-0.1,0.7-0.3l1-1c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-1,1c-0.4,0.4-0.4,1,0,1.4C19.5,6.9,19.7,7,20,7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.4226510476556bc5a86b4a153be20fe4.svg";
export { ForwardRef as ReactComponent };